import { useMemo, useState } from 'react';
import UI from '../../ui';
import { countries, ICountry, TCountryCode } from 'countries-list';
import extractEntries from '../../helpers/extractKeys';
import { uniq } from 'lodash';
import React from 'react';
import useOnboardingState from './useOnboardingState';
import OnboardingMap from './OnboardingMap';
import TravelerStatus from '../../components/TravelerStatus';

const continentDict = {
  AF: 'Africa',
  AN: 'Antarctica',
  AS: 'Asia',
  EU: 'Europe',
  NA: 'North America',
  OC: 'Oceania',
  SA: 'South America',
};

const options = extractEntries(countries).map(({ key, value }) => ({ label: value.name, value: key }));
const continents = uniq(extractEntries(countries).map(({ value }) => value.continent));

type filteredCountries = {
  country: ICountry
  code: TCountryCode
}[];

export const SelectCountries: React.FC<{ filteredCountries: filteredCountries, toggleAdd: (country: TCountryCode) => void, selectedCountries: TCountryCode[] }> = ({ filteredCountries, toggleAdd, selectedCountries }) => {
  return (
    <UI.VerticalLayout overflow="scroll" minHeight="200px">
      <UI.HorizontalLayout wrap="wrap" gap={5}>
        {filteredCountries.map(({ country, code }, i) =>
          <UI.Chip key={i} content={country.name} onClick={() => toggleAdd(code)} selected={selectedCountries.includes(code)} />,
        )}
      </UI.HorizontalLayout>
    </UI.VerticalLayout>
  );
};

const VisitedCountriesStep: React.FC = () => {
  const [continent, setContinet] = useState(continents[0]);
  const { countries: selectedCountries, addCountry, removeCountry, setCountries } = useOnboardingState();

  const filteredCountries = useMemo(() => extractEntries(countries).map(({ value, key }) => ({ country: value, code: key })).filter(c => c.country.continent === continent), [continent]);

  const toggleAdd: (country: TCountryCode) => void = (country) => {
    if (selectedCountries.includes(country)) {
      removeCountry(country);
    }
    else {
      addCountry(country);
    }
  };

  return (
    <UI.VerticalLayout overflow="scroll" width="100%" gap={5}>
      <UI.VerticalLayout gap={20}>
        <UI.VerticalLayout gap={10}>
          <OnboardingMap />
          <TravelerStatus countries={selectedCountries} />
        </UI.VerticalLayout>
        <UI.VerticalLayout gap={10}>
          <UI.VerticalLayout>
            <UI.Text weight="bold" size="title">Which countries have you travelled to?</UI.Text>
            <UI.Text>Select and add as many as you can</UI.Text>
          </UI.VerticalLayout>
          <UI.Autocomplete
            options={options}
            label=""
            placeHolder="Add a country"
            selected={selectedCountries}
            onSelect={setCountries}
            adornment={<UI.Icon name="map" />}
          />
          <UI.Tabs options={continents.sort((a, b) => a.localeCompare(b)).map(v => ({ label: continentDict[v], value: v }))} value={continent} onChange={setContinet} />
        </UI.VerticalLayout>
      </UI.VerticalLayout>

      <SelectCountries filteredCountries={filteredCountries} selectedCountries={selectedCountries} toggleAdd={toggleAdd} />
    </UI.VerticalLayout>
  );
};

export default VisitedCountriesStep;
